<template>
  <div class="add headFixed bodyPd hasBotBtns">
    <div class="fixed_head">
      <div class="content">
        <div class="go_back">
          <span @click="$router.back(-1)" class="goBackBtn"></span>
          <span class="titles">设备管理</span>
          <span class="right addHome" @click="addRoom()">添加</span>
        </div>
      </div>
    </div>

    <!-- 住宅列表 -->
    <div class="roomWrapper">
      <!--      <ul class="roomList clear">-->
      <!--        <li v-for="(data,index) in list" :key="index" @click="addEq(data.id)" >-->
      <!--          <span class="img"></span>-->
      <!--          <p>-->
      <!--            {{data.name}}-->
      <!--          </p>-->
      <!--        </li>-->
      <!--      </ul>-->
      <div class="list list_prev list_normal">
        <p class="titleTip">请选择设备名称或所在房间</p>
        <div class="item choose-item" :class="index == currentIndex ? 'choose-active' : ''"
             v-for="(data, index) in list" :key="index" @click="chooseRoom(index)">
          <p>
            {{ data.name }}
            <span class="icon-check"></span>
          </p>
        </div>
      </div>
      <Empty v-if="!(list && list.length > 0)"></Empty>
    </div>
    <div class="botBtns">
      <div>
        <mt-button size="large" class="btn-orange" @click="goHome">返回首页</mt-button>
        <mt-button size="large" class="btn-primary" @click="onSubmit">确定</mt-button>
      </div>
    </div>
    <mt-popup v-model="popupVisible">
      <div class="smart-modal">
        <h1>添加房间</h1>
        <input type="text" name="" id="" v-model="homeName"/>
        <div class="smart-modal-foot">
          <span @click="handleClick">取消</span>
          <span @click="handleAdd">确定</span>
        </div>
      </div>
    </mt-popup>
  </div>
</template>
<script>
import {Popup, Toast} from 'mint-ui';
import Empty from '../../commen/empty';

export default {
  name: 'add',
  data() {
    return {
      // 最后提交的参数
      number: null,
      name: null,
      password: null,
      useSceneId: null,
      roomId: null,
      type: null,

      popupVisible: false,
      homeName: null,
      list: [],
      currentIndex: 0,
      disabled: false
    };
  },
  mounted() {
    this.useSceneId = this.$route.params.sceneId;
    let params = this.Store.getEqInfo();
    console.log(params);
    if (!params) {
      this.goHome();
    }
    this.name = params.name;
    this.number = params.number;
    this.password = params.password;
    this.sceneId = params.sceneId;
    this.type = params.type;
    this.getEqRoomList();

    // 编辑修改场景
    if (this.getType() == 2) {
      this.iotDeviceId = this.$route.query.id;
      this.eqDetail(this.iotDeviceId);
    }
  },
  components: {Empty},
  methods: {
    getType() {
      return this.$route.params.type;
    },
    goHome() {
      this.$router.push({
        name: 'Equipment',
        params: {}
      });
    },
    eqDetail(id) {
      this.Api.eqDetail(id, msg => {
        if (msg.data) {
          let data = msg.data;
          this.number = data.number;
          this.name = data.name;
          this.password = data.password;
          this.iotDeviceId = data.iotDeviceId;

          let list = this.list;
          this.roomId = data.roomId;
          for (let i = 0; i < list.length; i++) {
            if (list[i].id == data.roomId) {
              this.currentIndex = i;
            }
          }
        }
      });
    },
    getEqRoomList() {
      let str = '';
      let sceneId = this.$route.params.sceneId;
      str = str + 'pageNo=1';
      str = str + '&pageSize=100';
      str = str + '&sceneId=' + sceneId;
      this.Api.eqRoomList(str, msg => {
        if (msg.code === 200) {
          this.list = msg.data;

          if (this.list && this.list.length > 0) {
            this.roomId = this.list[0].id;
          }

          if (this.getType() == 2) {
            let list = this.list;
            for (let i = 0; i < list.length; i++) {
              if (list[i].id == this.roomId) {
                this.currentIndex = i;
              }
            }
          }
        }
      });
    },
    handleClick() {
      this.popupVisible = false;
    },
    addRoom() {
      this.popupVisible = true;
    },
    handleAdd() {
      if (this.homeName) {
        let params = {};
        params.name = this.homeName;
        params.sceneId = this.sceneId;
        if (this.list.length >= 100) {
          this.popupVisible = false;
          Toast('设备名称最多只能添加100种');
        } else {
          this.Api.eqRoomAdd(params, () => {
            this.getEqRoomList();
            this.popupVisible = false;
            this.homeName = null;
          });
        }
        this.popupVisible = false;
        this.homeName = null;
      }
    },
    chooseRoom(index) {
      let list = this.list;
      this.currentIndex = index;
      this.roomId = list[index].id;
    },
    addEq() {
      let params = {};
      this.disabled = true;
      let data = {
        "number": this.number,
        "name": this.name,
        "password": this.password,
        "roomId": this.roomId,
        "iotDeviceId": this.iotDeviceId,
        "type": this.type
      }
      // params.number = this.number;
      // params.name = this.name;
      // params.password = this.password;
      // params.useSceneId = this.sceneId;
      // params.roomId = this.roomId;
      // params.iotDeviceId = this.iotDeviceId;
      this.Api.eqBind(
          data,
          msg => {
            this.disabled = false;
            if (msg.code === 200) {
              Toast('添加成功');
              this.$router.push({
                path: '/equipment'
              });
              // this.Store.delEqInfo();
            } else {
              Toast(msg.message);
            }
          },
          () => {
            this.disabled = false;
          }
      );
    },
    editScens() {
      let params = {};
      // params.id = this.iotDeviceId;
      params.roomId = this.roomId;
      params.iotDeviceId = this.iotDeviceId;
      params.sceneId = this.sceneId
      this.Api.updateBind(params, msg => {
        if (msg.code === 200) {
          Toast('修改成功');
          this.$router.push({
            path: '/equipment'
          });
        } else {
          Toast(msg.message);
        }
      });
    },
    onSubmit() {
      let flag = this.getType();
      if (flag == 1) {
        this.addEq();
      }
      if (flag == 2) {
        this.editScens();
      }
    }
  }
};
</script>

<style scoped>
@import url('../equipment.css');

.list_prev .item {
  background-image: none;
}

.roomWrapper {
  margin-top: 55px;
}

.list_prev .item:last-child {
  border-bottom: none;
}

.titles {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/equipment/scene/chooseRoom.vue